import { memo, FC, useEffect } from 'react'

import { useSetFocus } from '@please/lrud'

import { Button } from '@/components/Button/Button'
import { VideoOverlayCountdown } from '@/components/CountdownEvent/VideoOverlayCountdown'
import {
  VideoOverlay,
  VideoOverlayTypes,
} from '@/components/VideoPlayer/hooks/useVideoOverlay'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'

import {
  VideoEndedOverlayContainer,
  VideoEndedOverlayContent,
  VideoEndedOverlayTitle,
  VideoEndedOverlayNote,
  ActionWrapper,
  CountdownWrapper,
} from './styles'

const VideoEndedOverlayRaw: FC<{
  onExitButton?: () => void
  isChannelEventType: boolean
  overlayData: Nullable<VideoOverlay>
  setVideoOverlay: (value: Nullable<VideoOverlay>) => void
  isFullscreen?: boolean
  isStageHome?: boolean
  focusIdPrefix?: string
}> = ({
  focusIdPrefix = '',
  onExitButton,
  isChannelEventType,
  overlayData,
  setVideoOverlay,
  isFullscreen = false,
  isStageHome = false,
}) => {
  const { t } = useCommonTranslation()
  const setFocus = useSetFocus()
  const focusId = focusIdPrefix + 'VideoEndedOverlay'

  useEffect(() => {
    setFocus(focusId)
  }, [])

  const isEndenOverlayType =
    overlayData?.overlayType === VideoOverlayTypes.ENDED

  const renderContent = () => {
    if (isEndenOverlayType) {
      const title = isChannelEventType
        ? t('eventVideoOver')
        : t('mediaVideoOver')
      const text = isChannelEventType
        ? t('eventVideoOver2')
        : t('mediaVideoOver2')

      return (
        <>
          <VideoEndedOverlayTitle>{title}</VideoEndedOverlayTitle>
          <VideoEndedOverlayNote>{text}</VideoEndedOverlayNote>
        </>
      )
    }
    if (
      overlayData?.overlayType === VideoOverlayTypes.COUNTDOWN &&
      overlayData.event
    ) {
      const event = overlayData.event

      return (
        <>
          <VideoEndedOverlayTitle>
            {t('eventStartsSoon')}
          </VideoEndedOverlayTitle>
          <CountdownWrapper>
            <VideoEndedOverlayNote>{event.name}</VideoEndedOverlayNote>
            <VideoOverlayCountdown startTime={event.startTime} />
          </CountdownWrapper>
        </>
      )
    }
  }

  const onClose = () => {
    isEndenOverlayType &&
      setVideoOverlay({ overlayType: VideoOverlayTypes.BLOCKED })
    onExitButton?.()
  }

  return (
    <VideoEndedOverlayContainer
      $isFullscreen={isFullscreen}
      $isStageHome={isStageHome}
    >
      <VideoEndedOverlayContent>{renderContent()}</VideoEndedOverlayContent>
      {isFullscreen && (
        <ActionWrapper focusId={focusId} isTrap={isFullscreen}>
          <Button text={t('close')} onClick={onClose} />
        </ActionWrapper>
      )}
    </VideoEndedOverlayContainer>
  )
}

export const VideoEndedOverlay = memo(VideoEndedOverlayRaw)
